import styled from "styled-components";
import ArrowBlueDown from '../../containers/assets/arrow-blue-down.svg';

const Styled = {};

Styled.BodyWrapper = styled.div`
  background: #e5e5e5;
  padding: 43px 62px 0;
  width: 100%;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  color: #000;

  .loader {
    max-width: 800px;

    .loader-inner {
      div {
        margin-left: auto;
        margin-right: auto;
        margin-top: 100px;
        border-color: #2a4169;
      }
    }
  }
`;

Styled.Title = styled.h2`
  font-weight: bold;
  font-size: 30px;
  line-height: 100%;
  margin-bottom: 22px;
`;

Styled.Paragraph = styled.p`
  font-weight: 400;
  font-size: 18px;
`;

Styled.Steps = styled.div`
  margin-top: 35px;
  display: flex;
  gap: 40px;
  max-width: 1120px;
  align-items: stretch;
  justify-content: space-between;
}
`;

Styled.Step = styled.div`
  padding: 22px 25px 28px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);
  width: calc(100% / 3 - 40px / 2);

  &.blue {
    background-color: #EBF2FF;
  }
  
  &.ivory {
    background-color: #FFF8EB;
  }
  
  &.white {
    background-color: #fff;
  }
`;

Styled.StepTitle = styled.h3`
  font-weight: 700;
  font-size: 20px;
  line-height: 100%;
  text-align: center;

  &:after {
    display: block;
    content: '';
    width: calc(100% - 140px);
    height: 1px;
    background: rgba(42, 65, 105, 0.2);
    margin: 14px auto 10px;
  }
`;

Styled.StepParagraph = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 19px;

  &.small {
    font-size: 14px;
    margin-bottom: 2px;
  }
  
  &.no-margin {
    margin-bottom: 0;
  }
`;

Styled.StepOrderItems = styled.ul`
  padding: 0;
  margin: 0;
`;

Styled.StepOrderItem = styled.li`
  font-size: 16px;
  line-height: normal;
  background: #fff;
  padding: 6px 14px 3px;
  border: 1px solid #2A4169;
  margin-bottom: 40px;
  position: relative;

  &:after {
    display: block;
    content: '';
    position: absolute;
    bottom: -30px;
    left: 50%;
    transform: translateX(-50%);
    width: 7px;
    height: 30px;
    background: url(${ArrowBlueDown}) no-repeat center center;
  }

  &:last-child {
    margin-bottom: 0;
  }
    
  &:last-child:after {
    display: none;
  }
`;

Styled.Gap = styled.div`
  margin-bottom: 120px;
`;

Styled.Image = styled.img`
  max-width: 100%;
  margin-bottom: 19px;
`;

Styled.List = styled.ul`
  list-style: disc;
  margin-bottom: 0;
  padding-left: 22px;
`;

Styled.ListItem = styled.li`
  line-height: normal;
  margin-top: 10px;
`;

export default Styled;


// WEBPACK FOOTER //
// ./src/components/decisions/style.js